import { UserQualificationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'
import React from 'react'
import { ContentUserQualification } from '@tabeeb/modules/contentUsers/components/ContentUserQualification'
import { OverflowInlineList, Subheader3 } from '@collaborate-health/uikit'

interface ContentUserQualificationsProps {
  qualifications: UserQualificationResponse[]
}

const ContentUserQualifications: React.FC<ContentUserQualificationsProps> = ({ qualifications }) => {
  if (qualifications.length === 0) {
    return <Subheader3>No qualifications required</Subheader3>
  }

  return (
    <OverflowInlineList
      items={qualifications}
      getItemKey={(q) => q.QualificationId}
      renderItem={(q) => <ContentUserQualification qualification={q} />}
      renderHiddenItem={(q) => <ContentUserQualification qualification={q} variant='text' />}
      hiddenListHeader={<Subheader3>Qualifications</Subheader3>}
      gap={6}
      tooltipProps={{
        sx: {
          backgroundColor: '#3333331A',
        },
      }}
    />
  )
}

export default ContentUserQualifications

